import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { TasApplicationExtension as TasApplication } from 'tio-data/data/resources/tas-application.ext';
import EditableRow from './edit-scholarships/editable-row.gts';
import { fn } from '@ember/helper';
import { t } from 'ember-intl';
import type Owner from '@ember/owner';
import Button from 'tio-ui/components/button';
import { on } from '@ember/modifier';

type Scholarship = {
  scholarshipAmount: number;
  scholarshipName: string;
};

interface TuitionAssistanceProgramDetailsAppDetailsEditScholarshipsSignature {
  Args: {
    application: TasApplication;
    onUpdate: (arg0: Scholarship[]) => void;
    scholarships: Scholarship[];
  };
  Element: HTMLDivElement;
}

export default class TuitionAssistanceProgramDetailsAppDetailsEditScholarshipsComponent extends Component<TuitionAssistanceProgramDetailsAppDetailsEditScholarshipsSignature> {
  @tracked scholarships: Scholarship[] = [];

  constructor(
    owner: Owner,
    args: TuitionAssistanceProgramDetailsAppDetailsEditScholarshipsSignature['Args']
  ) {
    super(owner, args);
    const scholarships = this.args.scholarships || [];
    this.scholarships = scholarships.map((scholarship) => {
      return { ...scholarship };
    });
  }

  addScholarship = () => {
    this.scholarships = [...this.scholarships, { scholarshipName: '', scholarshipAmount: 0 }];
    this.didUpdateScholarships();
  };

  removeScholarship = (index: number) => {
    const scholarshipsCopy = [...this.scholarships];
    scholarshipsCopy.splice(index, 1);
    this.scholarships = scholarshipsCopy;
    this.didUpdateScholarships();
  };

  didUpdateScholarships = () => {
    this.args.onUpdate?.(this.scholarships);
  };

  didUpdateScholarshipAtIndex = (index: number, updatedModel: Scholarship) => {
    this.scholarships.splice(index, 1, updatedModel);
    this.didUpdateScholarships();
  };

  <template>
    <div class="w-full" ...attributes>
      {{#each this.scholarships as |scholarship index|}}
        <EditableRow
          @scholarship={{scholarship}}
          @application={{@application}}
          @onRemove={{fn this.removeScholarship index}}
          @onUpdate={{fn this.didUpdateScholarshipAtIndex index}}
        />
      {{/each}}

      <Button
        @appearance="outlined"
        {{on "click" this.addScholarship}}
        class="!text-base my-8 uppercase"
      >
        {{t "tuition_assistance.program_details.courses.add_a_scholarship"}}
      </Button>
    </div>
  </template>
}
